import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { Button, Loader, Table } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import QuotePromotionModel from '../components/QuotePromotionModal';

import { Api } from '@brokerage/utils/Api';

const QuotePromotionsList = ({ mobile_app }) => {
  const [data, setData] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [promotion, setPromotion] = useState(null);

  useEffect(() => {
    loadPromotions();
  }, []);

  const loadPromotions = () => {
    setLoading(true);

    Promise.all([
      Api.loadAgencyMobileAppAAQQuotePromotions(mobile_app.guid),
      Api.loadAllCarriers(),
      Api.loadAllAnnuityProducts()
    ]).then(response => {
      const promotions = response[0].data;
      const carriers = response[1].data;
      const products = response[2].data;
      const carrier_options = carriers.map(carrier => ({
        label: `${carrier.name} (ID: ${carrier.id})`,
        value: carrier.id
      }));
      const product_options = products.map(fp => ({
        label: `${fp.product_name} (ID: ${fp.id})`,
        value: fp.id,
        carrier_id: fp.carrier_id
      }));

      setData(promotions);
      setCarriers(carrier_options);
      setProducts(product_options);

      setLoading(false);
    });
  };

  const handleDelete = (id, e) => {
    e.stopPropagation();
    window.scrollTo(0, 0);

    setLoading(false);

    Api.deleteMobileAppAAQQuotePromotion(id)
      .then(() => {
        loadPromotions();
      })
      .catch(() => setLoading(false));
  };

  const handleSave = new_promotion_details => {
    Api.updateMobileAppAAQQuotePromotion(promotion.id, new_promotion_details).then(() => {
      setPromotion(null);
      loadPromotions();
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <QuotePromotionModel
        carriers={carriers}
        onClose={setPromotion.bind(null, null)}
        onSave={handleSave}
        products={products}
        promotion={promotion}
        show={!!promotion}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button
          onClick={setPromotion.bind(null, {
            carrier_id: '',
            product_id: '',
            mobile_app_guid: mobile_app.guid
          })}
        >
          New Quote Promotion
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'guid',
            label: 'GUID'
          },
          {
            label: 'Carrier',
            id: 'carrier_id',
            render: promotion => {
              const carrier = carriers.find(c => c.value === promotion.carrier_id);

              return carrier ? carrier.label : null;
            }
          },
          {
            label: 'Order',
            id: 'order'
          },
          {
            label: 'Active',
            id: 'order',
            textCenter: true,
            render: promotion =>
              promotion.is_active ? (
                <i
                  className='mdi mdi-check-bold'
                  style={{ fontSize: 20, color: Colors.GREEN.hex }}
                />
              ) : null
          },
          {
            label: 'Start Date',
            id: 'start_date',
            render: promotion => {
              return promotion.start_date
                ? format(new Date(promotion.start_date), 'MM/dd/yyyy')
                : null;
            }
          },
          {
            label: 'End Date',
            id: 'end_date',
            render: promotion =>
              promotion.end_date ? format(new Date(promotion.end_date), 'MM/dd/yyyy') : null
          },
          {
            id: 'actions',
            render: promotion => {
              return (
                <Button
                  backgroundColor={Colors.RED.hex}
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, promotion.id)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={data}
        onRowClick={setPromotion}
        placeholder='No Quote Promotions Yet'
      />
    </>
  );
};

QuotePromotionsList.propTypes = {
  mobile_app: PropTypes.object
};

export default QuotePromotionsList;
